require('./bootstrap');

import 'chart.js/dist/chart';
import "select2/dist/js/select2";
import 'bootstrap-datepicker';

import ReactLoader from "react-loader";
import Form from "./components/userApplication/Form";
import UserDocuments from "./components/UserDocuments";
import Notification from "./components/Notification";
import AccountStateAct from "./components/AccountStateAct";
import Register from './components/Register';
import DeleteConfirmationModal from './components/DeleteConfirmationModal';

const react = new ReactLoader('#app');
react.component('application-form', Form);
react.component('user-documents', UserDocuments);
react.component('notification', Notification);
react.component('account-state-act', AccountStateAct);
react.component('register', Register);
react.component('delete-confirmation-modal', DeleteConfirmationModal);
react.render();

$(document).ready(function () {
    $('.select2').select2();

    $('.select2-simple').select2({
        minimumResultsForSearch: Infinity
    });

    $('.select2-multiple').select2();

    $(document).on('click', '.notification-dropdown .dropdown-menu', function (e) {
        e.stopPropagation();
    });

    /**
     * Mobile Sidebar Toggle
     */
    $('.sidebar-mobile-toggle').on('click', function () {
        $('body').toggleClass('sidebar-mobile-show');
    });

    function initializeCharts() {
        let dynamicColors = function() {
            let r = Math.floor(Math.random() * 255);
            let g = Math.floor(Math.random() * 255);
            let b = Math.floor(Math.random() * 255);
            return "rgba(" + r + "," + g + "," + b + ", 1)";
        };

        if(window.mainChargingChart) {
            let datasets = new Array();
            if(window.mainChargingChart.calc_sum) 
                datasets.push({
                    label: 'Нараховано',
                    data: window.mainChargingChart.calc_sum,
                    backgroundColor: 'rgba(0,190,252, 1)'
                })
            if(window.mainChargingChart.pay_sum) 
            datasets.push({
                label: 'Оплачено',
                data: window.mainChargingChart.pay_sum,
                backgroundColor: 'rgba(240,173,60, 1)'
            }) 
            if(window.mainChargingChart.debt_end) 
            datasets.push({
                label: 'Стан рахунку',
                data: window.mainChargingChart.debt_end,
                backgroundColor: 'rgba(230,59,122,1)'
            })  
            let mainChargingChart = new Chart(document.getElementById('mainChargingChart'), {
                type: 'bar',
                data: {
                    labels: ['Січ', 'Лют', 'Бер', 'Кві', 'Тра', 'Чер', 'Лип', 'Сер', 'Вер', 'Жов', 'Лис', 'Гру'],
                    datasets: datasets
                },
                options: {
                    maintainAspectRatio: false,
                    legend: {
                        display: true,
                        position: 'bottom'
                    },
                    scales: {
                        xAxes: [{
                            gridLines: {
                                drawOnChartArea: false
                            }
                        }],
                        yAxes: [{
                            gridLines: {
                                drawOnChartArea: false
                            },
                            ticks: {
                                maxTicksLimit: 4
                            }
                        }]
                    }
                }
            });
        }

        if(window.forecastChart) {
            let forecastChart = new Chart(document.getElementById('forecastChart'), {
                type: 'bar',
                data: {
                    labels: ['Січ.', 'Лют.', 'Бер.', 'Квіт.', 'Трав.', 'Черв.', 'Лип.', 'Серп.', 'Вер.', 'Жовт.', 'Лист.', 'Груд.'],
                    datasets: [{
                        label: window.forecastChart.lastYear,
                        data: window.forecastChart.lastYearData,
                        backgroundColor: 'rgba(223, 157, 125, 0.5)'
                    },
                        {
                            label: 'Прогноз',
                            data: window.forecastChart.plan,
                            backgroundColor: 'rgba(61, 177, 223, 0.5)'
                        }]
                },
                options: {
                    maintainAspectRatio: false,
                    legend: {
                        display: true,
                        position: 'bottom'
                    },
                    scales: {
                        xAxes: [{
                            gridLines: {
                                drawOnChartArea: false
                            }
                        }],
                        yAxes: [{
                            gridLines: {
                                drawOnChartArea: false
                            },
                            ticks: {
                                maxTicksLimit: 4
                            }
                        }]
                    }
                }
            });
        }

        if (window.volumeChart) {
            let lineChart = new Chart(document.getElementById('lineChart'), {
                type: 'line',
                data: {
                    labels: ['Січ.', 'Лют.', 'Бер.', 'Квіт.', 'Трав.', 'Черв.', 'Лип.', 'Серп.', 'Вер.', 'Жовт.', 'Лист.', 'Груд.'],
                    datasets: [
                        ...window.volumeChart.map(function (chart) {
                            return {
                                label: chart.name,
                                data: chart.data,
                                borderColor: dynamicColors(),
                                backgroundColor: 'rgba(0, 0, 0, 0)'
                            }
                        })
                    ]
                },
                options: {
                    maintainAspectRatio: false,
                    legend: {
                        display: true,
                        position: 'bottom'
                    },
                    scales: {
                        xAxes: [{
                            gridLines: {
                                drawOnChartArea: false
                            }
                        }],
                        yAxes: [{
                            gridLines: {
                                drawOnChartArea: false
                            },
                            ticks: {
                                maxTicksLimit: 4
                            }
                        }]
                    }
                }
            });
        }
    }

    initializeCharts();

    /**
     * Profile edit
     */
    let invalidFeedback = $(".form-content-edit").find(".invalid-feedback").parents(".form-content-edit");
    if(invalidFeedback) {
        invalidFeedback.find('.form-content').toggle();
        invalidFeedback.find('.form-edit').toggle();

        let btn = invalidFeedback.find('.form-edit-icon');
        if(btn.hasClass('fa fa-chevron-up')) {
            btn.removeClass('fa fa-chevron-up').addClass('icon-pen');
        } else if(btn.hasClass('icon-pen')) {
            btn.removeClass('icon-pen').addClass('fa fa-chevron-up');
        }
    }

    $(".form-edit-btn").click(function(event){
        let $this =  $(event.target);
        let contentEdit = $this.parents(".form-content-edit");
        let btn = contentEdit.find('.form-edit-icon');

        if(btn.hasClass('fa fa-chevron-up')) {
            btn.removeClass('fa fa-chevron-up').addClass('icon-pen');
        } else if(btn.hasClass('icon-pen')) {
            btn.removeClass('icon-pen').addClass('fa fa-chevron-up');
        }

        contentEdit.find('.form-content').slideToggle();
        contentEdit.find('.form-edit').slideToggle();
    });

    $('.update-notification-chanel').on('change',function(){
        let $this = $(this).parents().find('#inform-form');
        $.ajax({
            url: $this.attr('action'),
            method: $this.attr('method'),
            data: $this.serialize(),
        });
    });

    $('.update-flags-form').on('change',function(){
        let $this = $(this).parents().find('#flags-form');
        $.ajax({
            url: $this.attr('action'),
            method: $this.attr('method'),
            data: $this.serialize(),
        });
    });

    $('#accept_terms_no_bill').on('change', function (e) {
        $("#refuse_paper_bill").prop('checked', e.target.checked);
    })

    $('#refuse_paper_bill').on('change', function (e) {
        $("#accept_terms_no_bill").prop('checked', e.target.checked);
    });

});
